<template>
  <form-group class="input-with-units"
              :label="label"
              :errors="internalErrors"
              @focus="focus">
    <div uk-grid class="uk-grid-small">
      <div>
        <input ref="primaryInput"
               type="number"
               step="any"
               min="0"
               class="uk-input input-with-units__value"
               :class="inputCss"
               v-model.number="internalValue.value"
               :placeholder="placeholder"
               :disabled="disabled"
               @input="onInput">
      </div>
      <div>
        <select v-if="hasMultipleUnits"
                class="uk-select input-with-units__unit"
                v-model="internalValue.unit"
                @change="onInput">
          <option v-for="unit in availableUnits" :value="unit">
            {{translateUnit(unit)}}
          </option>
        </select>
        <span v-else
              class="uk-input uk-form-blank input-with-units__unit--default">
          {{translateUnit(defaultUnit)}}
        </span>
      </div>
    </div>
  </form-group>
</template>

<script>
import { camelCase, pick } from 'lodash';
import ComplexInput from '@/mixins/ComplexInput';

export default {
  name: 'input-with-units',
  mixins: [ComplexInput],
  props: {
    placeholder: String,
    name: {
      type: String,
      required: true,
    },
    availableUnits: {
      type: Array,
      required: true,
    },
  },
  data() {
    let value;
    if (this.value) {
      value = pick(this.value, ['value', 'unit']);
    } else {
      value = { value: null, unit: null };
    }
    if (!value.unit) value.unit = this.availableUnits[0];
    return { internalValue: value };
  },
  computed: {
    hasMultipleUnits() {
      return this.availableUnits.length > 1;
    },
    defaultUnit() {
      return this.availableUnits[0];
    },
  },
  methods: {
    onInput() {
      let value = null;
      if (this.internalValue && this.internalValue.value) {
        value = pick(this.internalValue, ['value', 'unit']);
      }
      this.$emit('input', value);
      this.$emit('change', value);
    },
    translateUnit(unit) {
      return this.$t(`units.${this.name}.${camelCase(unit)}`);
    },
  },
};
</script>

<style scoped lang="scss">
.input-with-units__unit--default {
  padding: {
    left: 0;
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// InputWithUnits.vue?46bb5c96